import React, { useContext } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import AppContext from "../../context/AppContext";

const loginRouteByRole = {
  student: "/student/login",
  teacher: "/teacher/login",
  admin: "/admin/login",
};

const ProtectedRoute = ({ allowedRole }) => {
  const location = useLocation();

  const { authToken, userType, authLoading } = useContext(AppContext);

  if (authLoading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  const isLoggedIn = Boolean(authToken);
  const hasCorrectRole = userType === allowedRole;

  if (!isLoggedIn || !hasCorrectRole) {
    return (
      <Navigate
        to={loginRouteByRole[allowedRole] || "/"}
        state={{ from: location }}
        replace
      />
    );
  }

  return <Outlet />;
};

export default ProtectedRoute;